import React from 'react';
import { BrowserRouter, Navigate, Outlet, Route, Routes } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { AuroraBackdrop } from './components/AuroraBackdrop';
import { BrandMark } from './components/BrandMark';
import { DashboardShell } from './components/layout/DashboardShell';
import { Toaster } from './components/ui/Sonner';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { ThemeProvider, useTheme } from './contexts/ThemeContext';
import { Dashboard } from './pages/Dashboard';
import { Landing } from './pages/Landing';
import { Security } from './pages/Security';
import { Settings } from './pages/Settings';
import { Students } from './pages/Students';
function Splash({
  message
}: {
  message: string;
}) {
  return <div className="relative grid min-h-screen w-full place-items-center px-6" data-id="element-0" data-mp="28ufmg62gz4gf">
      <AuroraBackdrop intensity="marketing" data-id="element-1" data-mp="28s2xva27hvue" />
      <div className="glass flex flex-col items-center gap-5 rounded-3xl px-10 py-9 text-center" data-id="element-2" data-mp="23w4ek0vqj40u">
        <BrandMark size="lg" withText={false} className="animate-float" data-id="element-3" data-mp="3ikqytzf4l45q" />
        <div data-id="element-4" data-mp="3mlavl1vse5rc">
          <p className="text-sm font-semibold tracking-tight text-foreground" data-id="element-5" data-mp="3ml17xky7saot">Student Recorder</p>
          <p className="mt-1 text-xs text-muted-foreground" data-id="element-6" data-mp="3rbrc4uuwm7hx">{message}</p>
        </div>
        <Loader2 className="h-4 w-4 animate-spin text-brand" data-id="element-7" data-mp="5or2zhbcs60" />
      </div>
    </div>;
}

/** Requires a live Google session plus a satisfied master-password gate. */
function ProtectedRoute() {
  const {
    user,
    initializing,
    unlocked,
    profileLoading
  } = useAuth();
  if (initializing) return <Splash message="Restoring your secure session…" data-id="element-8" data-mp="38lrqkhy9vaj9" />;
  if (!user) return <Navigate to="/" replace data-id="element-9" data-mp="38kgocmkh6au9" />;
  if (profileLoading) return <Splash message="Checking your security profile…" data-id="element-10" data-mp="3dl4kfmnk9hvc" />;
  if (!unlocked) return <Navigate to="/security" replace data-id="element-11" data-mp="nvsub5qlapwh" />;
  return <Outlet data-id="element-12" data-mp="nv0z3w0wmu6q" />;
}

/** The master-password step, only reachable once Google sign-in succeeded. */
function SecurityRoute() {
  const {
    user,
    initializing,
    unlocked
  } = useAuth();
  if (initializing) return <Splash message="Restoring your secure session…" data-id="element-13" data-mp="34x0pdwmt31s" />;
  if (!user) return <Navigate to="/" replace data-id="element-14" data-mp="3udkn7x6lywax" />;
  if (unlocked) return <Navigate to="/dashboard" replace data-id="element-15" data-mp="3uevui6z9im6s" />;
  return <Security data-id="element-16" data-mp="d4xr1jsx4jfh" />;
}
function AppToaster() {
  const {
    theme
  } = useTheme();
  return <Toaster theme={theme} position="top-right" richColors closeButton data-id="element-17" data-mp="85ukfuxai55e" />;
}
export function App() {
  return <ThemeProvider data-id="element-18" data-mp="3gkl9o0qdzc60">
      <AuthProvider data-id="element-19" data-mp="3gm63tp8sgt3c">
        <BrowserRouter data-id="element-20" data-mp="3glny8208l2ir">
          <Routes data-id="element-21" data-mp="3bmbe3p0r29jv">
            <Route path="/" element={<Landing data-id="element-23" data-mp="3bncp5thrmw1l" />} data-id="element-22" data-mp="3bmti57tnls2c" />
            <Route path="/security" element={<SecurityRoute data-id="element-25" data-mp="3qb7m5m2t3mkh" />} data-id="element-24" data-mp="3bo4kd37garrc" />
            <Route element={<ProtectedRoute data-id="element-27" data-mp="3qbzcoihjqu3w" />} data-id="element-26" data-mp="3qc96kh5pplev">
              <Route element={<DashboardShell data-id="element-29" data-mp="3lkhbpufiwtix" />} data-id="element-28" data-mp="3qd0st1df66sh">
                <Route path="/dashboard" element={<Dashboard data-id="element-31" data-mp="3lieeapc1jy46" />} data-id="element-30" data-mp="3ljg09ouli50o" />
                <Route path="/students" element={<Students data-id="element-33" data-mp="2xtv7yfcjxveq" />} data-id="element-32" data-mp="2xun4bsdz3x62" />
                <Route path="/settings" element={<Settings data-id="element-35" data-mp="2sw207hvlotcc" />} data-id="element-34" data-mp="2xssga57enoxr" />
              </Route>
            </Route>
            <Route path="*" element={<Navigate to="/" replace data-id="element-37" data-mp="18e1a5lqg5qkk" />} data-id="element-36" data-mp="2stplddl52z3i" />
          </Routes>
        </BrowserRouter>
        <AppToaster data-id="element-38" data-mp="18by9m7ro4f1l" />
      </AuthProvider>
    </ThemeProvider>;
}